module.exports = __webpack_public_path__ + "static/media/test7_1.860eb320.png";